<template>
  <h2>{{ t("components.siteSettings.appVariant.title") }}</h2>
  <v-card elevation="3" class="my-5">
    <v-card-text>
      <v-row>
        <v-col md="10">
          <y-select
            v-model="selectedAppVariant"
            :items="Object.values(SiteInternalSettingsAppVariantEnum)"
            item-title="appVariant"
            :label="t('components.siteSettings.appVariant.description')"
            hide-details
            class="mb-2"
          />
        </v-col>
        <v-col md="2" class="d-flex align-items-center">
          <v-btn
            prepend-icon="mdi-cash-multiple"
            :text="t('form.save')"
            class="bg-error on-error mb-2"
            :loading="loading"
            :disabled="!canUpdate"
            @click="update"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { SiteInternalSettingsAppVariantEnum } from "@tableyeti/merchant-service";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

type AppVariant = keyof typeof SiteInternalSettingsAppVariantEnum;
const emit = defineEmits<{ updateInternalSettings: [string, AppVariant] }>();
const props = defineProps<{ appVariant?: SiteInternalSettingsAppVariantEnum; loading?: boolean }>();

const appVariant = computed(() => props.appVariant);
const loading = computed(() => props.loading);
const canUpdate = computed(() => selectedAppVariant.value !== appVariant.value);

const selectedAppVariant = ref<SiteInternalSettingsAppVariantEnum | undefined>(appVariant.value);

const update = () => {
  emit("updateInternalSettings", "appVariant", selectedAppVariant.value as AppVariant);
};
</script>
